import { Button } from "../ui/button";
import { Form } from "@remix-run/react";
import { Input } from "../ui/input";
import { useState } from "react";
import { useToast } from "~/components/ui/use-toast";

export default function Newsletter({
  noEmailNoGoodieLabel,
  welcomeToCommunityLabel,
  newsletterEmailLabel,
  newsletterButtonLabel,
  newsletterLabel,
}: {
  noEmailNoGoodieLabel: string;
  welcomeToCommunityLabel: string;
  newsletterEmailLabel: string;
  newsletterButtonLabel: string;
  newsletterLabel: string;
}) {
  const [email, setEmail] = useState<String | undefined>(undefined);
  const { toast } = useToast();

  const handleOnSubmit = async (event: any) => {
    event.preventDefault();
    if (!email) {
      toast({
        variant: "destructive",
        description: noEmailNoGoodieLabel,
      });
      return;
    }

    const response = await fetch("/newsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(email),
    });

    if (response.ok) {
      const subscribeResponse = await response.json();

      if (!subscribeResponse.success) {
        return toast({
          variant: "destructive",
          title: "Uh oh! Something went wrong.",
          description: "There was a problem with the request.",
        });
      }
      if (subscribeResponse.success) {
        return toast({
          variant: "default",
          description: welcomeToCommunityLabel,
        });
      }

      console.log("Newsletter subscribeResponse: ", subscribeResponse);
    }
  };

  return (
    <Form onSubmit={handleOnSubmit}>
      <div className="flex md:w-[90%] lg:w-[75%]">
        <Input
          aria-label="Email address"
          type="email"
          name="email"
          placeholder={newsletterEmailLabel}
          onChange={(e) => setEmail(e.target.value)}
        />

        <Button variant="secondary" type="submit">
          {newsletterButtonLabel}
        </Button>
      </div>

      <span className="text-xs text-[#888] font-light">{newsletterLabel}</span>
    </Form>
  );
}
